import { State } from 'interfaces/state'

export const publicFiltersSelector = (state: State) => state.app.publicdashboard
